import React, { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'dva';
import dayjs from 'dayjs';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import FocuseCouponStyled from './FocuseCouponStyled';
import webStorage from '@/utils/storageManager';
import CouponModal from '../CouponModal';

const FocusedAutoReply = (props) => {
  const disabled = props?.disabled;
  const dispatch = useDispatch();
  //选择自动回复弹窗开关
  const [openModal, setOpenModal] = useState(false);
  //删除弹框开关
  const [openDialog, setOpenDialog] = useState(false);
  //当前点击的卡片信息相关
  const [currentCardInfo, setCurrentCardInfo] = useState();
  const { couponList } = useSelector((state) => state.voucherEdit) || [];
  const { COUPON_TYPE = [] } = webStorage.get('DICTOBJ') || {};
  const typeList = COUPON_TYPE.map((item) => ({
    value: item.dictCode,
    name: item.nameZh,
  }));
  const isCanAddRule = couponList?.length < 5;
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  //删除确定
  const handleConfirm = () => {};
  //
  const handleAddClick = () => {
    setCurrentCardInfo();
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDeleteCoupon = (index) => {
    const newList = [...couponList];
    newList.splice(index, 1);
    console.log({ newList });
    dispatch({
      type: 'voucherEdit/save',
      payload: { couponList: newList },
    });
  };
  //选择规则弹出框的确认
  const onConfirm = (selectedInfo) => {
    //判断是新增还是编辑
    let updateAutoReplyList;
    if (currentCardInfo?.info?.id) {
      updateAutoReplyList = couponList.map((item, index) => {
        if (index === currentCardInfo?.index) {
          return { ...selectedInfo };
        }
        return item;
      });
    } else {
      updateAutoReplyList = [...couponList, selectedInfo];
    }
    dispatch({
      type: 'voucherEdit/save',
      payload: {
        couponList: updateAutoReplyList,
      },
    });
  };
  return (
    <FocuseCouponStyled>
      <Box className="card_wrapper">
        {couponList?.map((item, index) => (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            flexWrap="wrap"
            gap="12px 0"
            key={index}
          >
            <Box className="card_item">
              <Box
                sx={{
                  width: '238px',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    color: '#1565C0',
                    fontSize: '16px',
                    fontWeight: 600,
                    lineHeight: '22px',
                  }}
                >
                  {item.title}
                </Box>
                <Box>
                  <Box
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      color: '#BDC0C4',
                    }}
                  >
                    优惠券 有效期
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#424242',
                      gap: '0 2px',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: '16px',
                        fontWeight: 600,
                        lineHeight: '22px',
                      }}
                    >
                      {dayjs(item.beginTime).format('YYYY-MM-DD')}
                    </Box>
                    <Box
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        lineHeight: '14px',
                        transform: 'scale(0.83)',
                      }}
                    >
                      至
                    </Box>
                    <Box
                      sx={{
                        fontSize: '16px',
                        fontWeight: 600,
                        lineHeight: '22px',
                      }}
                    >
                      {dayjs(item.endTime).format('YYYY-MM-DD')}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  height: '100%',
                  paddingLeft: '35px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'column',
                }}
              >
                <Box>
                  <Box
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      color: '#BDC0C4',
                    }}
                  >
                    优惠券 ID
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#424242',
                      gap: '0 2px',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: '19.2px',
                        fontWeight: 600,
                        lineHeight: '22px',
                        transform: 'scale(0.83)',
                        marginLeft: '-4px',
                      }}
                    >
                      {item.id}
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      color: '#BDC0C4',
                    }}
                  >
                    优惠券 类型
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#424242',
                      gap: '0 2px',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: '19.2px',
                        fontWeight: 600,
                        lineHeight: '22px',
                        transform: 'scale(0.83)',
                        marginLeft: '-4px',
                      }}
                    >
                      {typeList.find((it) => it.value === item.typeName)?.name}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {!disabled && (
              <Box sx={{ marginRight: '24px', display: 'flex', gap: '0 16px' }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setCurrentCardInfo({ info: item, index });
                    setOpenModal(true);
                  }}
                  sx={{
                    width: '68px',
                    borderRadius: '24px',
                    height: '36px',
                    lineHeight: '36px',
                  }}
                >
                  替换
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    handleDeleteCoupon(index);
                  }}
                  sx={{
                    width: '68px',
                    borderRadius: '24px',
                    color: '#F50057',
                    borderColor: '#F50057',
                    height: '36px',
                    lineHeight: '36px',
                  }}
                >
                  删除
                </Button>
              </Box>
            )}
          </Box>
        ))}
        {isCanAddRule && !disabled && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            gap="12px 0"
          >
            <Box className="addRule"></Box>
            <Box sx={{ marginRight: '24px', display: 'flex', gap: '0 16px' }}>
              <Button
                variant="contained"
                onClick={handleAddClick}
                sx={{
                  width: '68px',
                  borderRadius: '24px',
                  height: '36px',
                  lineHeight: '36px',
                }}
              >
                添加
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      <DialogDataML
        open={openDialog}
        title={'提示'}
        content="您确定要删除优惠券吗？点击确定则删除成功；点击取消关闭弹框；删除后卡片样式如同坑位为空时。"
        handleClose={handleCloseDialog}
        handleConfirm={handleConfirm}
      ></DialogDataML>
      {openModal && (
        <CouponModal
          open={openModal}
          onClose={handleCloseModal}
          onConfirm={onConfirm}
          title="选择优惠券"
          selectedIds={[currentCardInfo?.info?.id]}
        />
      )}
    </FocuseCouponStyled>
  );
};
export default FocusedAutoReply;
